import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { LeaveAndUpcomingHistoryListType, LeaveStatus } from "../../redux/stcoTools/stcoToolsType";
import { CircularAvatar } from "../commons";

type AppProps = {
  data: LeaveAndUpcomingHistoryListType[] | [];
  tableHeader: TableHeadersType[];
  approvedLeave: number;
  balanceLeave: LeaveStatus;
};
const AllUserLeaveHistoryTableData = ({
  data,
  tableHeader,
  approvedLeave,
  balanceLeave,
}: AppProps) => {
  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?._id}>
              {tableHeader?.map((item: TableHeadersType) => {
                if (item?.value === "start_date") {
                  return <td>{itemData?.start_date}</td>;
                } else if (item?.value == "end_date") {
                  return <td>{itemData?.end_date}</td>;
                } else if (item?.value == "total_days") {
                  return <td>{itemData?.total_days}</td>;
                } else if (item?.value == "approved_by") {
                  return (
                    <td className="text-left" 
                    style={{minWidth:'170px'}}
                    >
                      <div
                        className="ml-2"
                        style={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                          gap: "7px",
                        }}
                      >
                        <CircularAvatar
                          name={`${itemData?.approved_by?.first_name} ${itemData?.approved_by?.last_name}`}
                          image={
                            itemData?.approved_by?.profile_pic &&
                            itemData?.approved_by?.profile_pic?.file_url
                          }
                        />
                        <div>
                          {`${itemData?.approved_by?.first_name} ${itemData?.approved_by?.last_name} `}
                        </div>
                      </div>
                    </td>
                  );
                } else if (item?.value == "leave_type") {
                  return (
                    <td style={{minWidth:'200px'}}>
                       <div
                          className="d-flex align-items-center"
                          style={{ gap: "10px" }}
                        >
                      <div>
                      <span
                        className={
                          itemData?.leave_type === "Unpaid Leave"
                            ? "status-incomplete"
                            : itemData?.leave_type === "Full time(Unpaid Leave)"
                            ? "status-Pending"
                            : "estimatePurchase"
                        }
                        style={{
                          fontWeight: 500,
                          borderRadius: "16px",
                          padding: "5px 10px",
                        }}
                      >
                        {itemData?.leave_type === "Unpaid Leave"
                          ? "Unpaid Leave"
                          : itemData?.leave_type === "Casual Leave"
                          ? "Casual Leave"
                          : itemData?.leave_type ===
                            "Casual leave(Unpaid Leave)"
                          ? "Casual Leave"
                          : "Unpaid Leave"}
                      </span>
                      </div>
                      {itemData?.leave_type === "Casual leave(Unpaid Leave)" && (
                            <div
                              className={"status-Pending"}
                              style={{
                                fontWeight: 500,
                                borderRadius: "16px",
                                padding: "5px 10px",
                              }}
                            >
                              Unpaid Leave
                            </div>
                          )}
                          </div>
                    </td>
                  );
                } else if (item?.value == "reason") {
                  return <td style={{minWidth:'220px'}}

                  >{itemData?.reason}</td>;
                }
              })}
            </tr>
          );
        })}
    </>
  );
};

export default AllUserLeaveHistoryTableData;
